const options = {
	print: false,
	download: false,
	selectableRows: 'none'
};

export { options };
